export default "__VITE_ASSET__DzcBsgPX__"